import { RefObject } from 'react';
import { createPortal } from 'react-dom';
import { MdLockOpen } from 'react-icons/md';
import { Popover, PopoverContent, Listbox, ListboxItem } from '@ds';

type UnblockShiftPopoverProps = {
  triggerRef: RefObject<HTMLButtonElement | null>;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onUnblock: () => void;
};

export const UnblockShiftPopover = ({ triggerRef, isOpen, onOpenChange, onUnblock }: UnblockShiftPopoverProps) => {
  const handleAction = () => {
    onUnblock();
    onOpenChange(false);
  };

  return createPortal(
    // @ts-expect-error HeroUI Popover types expect multiple children but triggerRef mode only needs content
    <Popover
      placement="right-start"
      triggerRef={triggerRef as RefObject<HTMLElement>}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      shouldCloseOnInteractOutside={(el) => el !== triggerRef.current && !triggerRef.current?.contains(el)}
    >
      <PopoverContent>
        <Listbox aria-label="Unblock Shift" onAction={handleAction}>
          <ListboxItem key="unblock" startContent={<MdLockOpen size={16} />}>
            Unblock Shift
          </ListboxItem>
        </Listbox>
      </PopoverContent>
    </Popover>,
    document.body,
  );
};
